import MainPageResponsibleSelect from './MainPageResponsibleSelect';

export default MainPageResponsibleSelect;
